<template>
  <div>
    <div
      class="floorFifth"
      :style="{ backgroundImage: 'url(' + backImg + ')' }"
    >
      <div class="title_box">
        <div class="en">COLOR AND TEXTURE OF ANTIBACTERIAL FLOOR</div>
        <div class="zh">高品质纹理创造科技之美</div>
        <div class="line"></div>
      </div>
      <div class="carousel_box">
        <el-carousel
          :interval="4000"
          type="card"
          height="390px"
          indicator-position="none"
          arrow="never"
          :autoplay="false"
          @change="ChangeCarousel"
          ref="carousel"
        >
          <!-- :loop="false" -->
          <el-carousel-item v-for="(item, index) in swiper_arr" :key="index">
            <img :src="item.src" style="height: 100%" class="img_cover" />
            <div class="zitiac" v-if="item.desc || item.summary">
              <p class="zitic">{{ item.summary }}</p>
              <p class="zitiz">{{ item.desc }}</p>
              <p class="zitid">{{ item.thickness }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="swiper_big_box">
        <div class="prev_box">
          <img src="../../assets/indexImg/左右 (1).png" alt="" />
        </div>
        <div class="swiper_box">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="swiper-container"
            v-if="swiper_arr.length > 0"
          >
            <swiper-slide v-for="(item, index) in swiper_arr" :key="index">
              <img
                :src="item.src"
                class="el_image img_cover"
                :class="activeIndex === index ? 'swiper_silde' : ''"
                @click="clickitem(index)"
              />
            </swiper-slide>
          </swiper>
        </div>
        <div class="next_box">
          <img src="../../assets/indexImg/左右.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    var that = this;
    return {
      swiperOption: {
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 40,
        navigation: {
          nextEl: ".next_box",
          prevEl: ".prev_box",
        },
        // centeredSlides: true,
        centeredSlidesBounds: true,

        on: {
          slideChangeTransitionStart: function () {
            that.$refs.carousel.setActiveItem(this.realIndex);
          },
        },
      },
      swiper_arr: [],
      activeIndex: 0,
      backImg: "",
    };
  },
  methods: {
    clickitem(index) {
      this.swiper.slideTo(index, 1000, false);
      this.activeIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    ChangeCarousel(val) {
      this.activeIndex = val;
      this.swiper.slideTo(val, 1000, false);
    },
  },
  mounted() {
    var index = Number(this.$route.query.id);
    var indata = Number(this.$route.query.in);
    // if (this.floorData.length === 0) {
    //   // setTimeout(() => {
    //     var obj = this.$store.state.floorData[index];
    //     this.backImg = obj.children[indata].beautiful_background;
    //     this.swiper_arr = obj.children[indata].beautiful_images_obj;
    //   // }, 500);
    // } else {
    if (index == 0) {
      var obj =
        this.$store.state.floorData[index] ||
        JSON.parse(localStorage.getItem("floorData"))[index];
      this.backImg = obj.children[indata].beautiful_background;
      this.swiper_arr = obj.children[indata].beautiful_images_obj;
    } else {
      var obj =
        this.$store.state.floorData[index] ||
        JSON.parse(localStorage.getItem("floorData"))[index];
      this.backImg = obj.beautiful_background;
      this.swiper_arr = obj.beautiful_images_obj;
    }

    // }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    floorData() {
      return this.$store.state.floorData;
    },
  },
  watch: {
    floorData(val) {
      console.log(val);
    },
  },
};
</script>

<style scoped lang='scss'>
.floorFifth {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  background-size: cover;
  .zitic {
    font-size: 18px;
    color: #fff;
    text-align: center;
    width: 100%;
   margin-bottom: 5px;
  }
  .zitid{
      font-size: 18px;
    color: #fff;
    text-align: center;
    width: 100%;
       margin-bottom: 5px;
  }
  .zitiz {
    font-size: 18px;
    color: #fff;
    width: 100%;
       margin-bottom: 5px;
  }
  .zitiac {
    position: absolute;
    bottom: 0px;
    width: 100%;
    text-align: center;
    padding-top: 5px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .title_box {
    width: 100vw;
    height: 9.3vh;
    padding-top: 16vh;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      line-height: 2.8vh;
      text-align: center;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      width: 100%;
      margin-top: -2vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .carousel_box {
    margin: 0 auto;
    width: 1200px;
    height: 390px;
    // height: 40.5vh;
    // margin-top: 40px;
    margin-top: 4vh;
    // overflow-y: hidden;
  }
  .swiper_big_box {
    // width: 1740px;
    width: 90.06vw;
    // height: 164px;
    height: 16.4vh;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    // margin-top: 51px;
    margin-top: 5.1vh;
    .swiper_silde {
      border: 1px solid #0fffff;
    }
    .prev_box {
      width: 94px;
      // height: 164px;
      height: 16.4vh;
      background: rgba(15, 255, 255, 0.2);
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 164px;
      line-height: 16.4vh;
      color: #ffffff;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.5s;
      img {
        display: block;
      }
    }
    .prev_box:hover,
    .next_box:hover {
      background: rgba(15, 255, 255, 0.6);
      transition: all 0.5s;
    }
    .next_box {
      width: 94px;
      // height: 164px;
      height: 16.4vh;
      background: rgba(15, 255, 255, 0.2);
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 164px;
      line-height: 16.4vh;
      text-align: center;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
      }
    }
    .next_box:focus {
      outline: none;
    }
    .prev_box:focus {
      outline: none;
    }
    .swiper_box {
      // width: 1490px;
      width: 77.6vw;
      // height: 164px;
      height: 16.4vh;
      .el_image {
        // width: 266px;
        width: 100%;
        // height: 16.4vh;
        height: 164px;
      }
      .el_image:hover {
        border: 1px solid #0fffff;
        cursor: url("../../assets/cursor.png"), none;
      }
    }
  }
}
</style>